import { render, staticRenderFns } from "./AppearanceWidget.vue?vue&type=template&id=6f515b84&"
import script from "./AppearanceWidget.vue?vue&type=script&lang=js&"
export * from "./AppearanceWidget.vue?vue&type=script&lang=js&"
import style0 from "./AppearanceWidget.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VInput } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VInput,
  VLayout,
  VSelect,
  VSwitch,
  VTextField,
})
